var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mx-4 pt-3"},[_c('tabs',{staticClass:"border-bottom",attrs:{"tabs":_vm.rutas}}),_c('div',{staticClass:"custom-scroll overflow-auto",staticStyle:{"height":"calc(100vh - 121px)"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }